import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ensures the viewer has Drive access (teammates), then embeds Google's preview.
const DrivePreview = ({ file, onClose }) => {
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    setStatus('loading');
    axios.post(`${API}/tasks/${file.task_id}/drive-attachments/${file.id}/access`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(() => alive && setStatus('ready'))
      .catch((e) => {
        if (!alive) return;
        setError(e.response?.data?.detail || 'Could not open this file');
        setStatus('error');
      });
    return () => { alive = false; };
  }, [file.id, file.task_id]);

  return (
    <div className="p-6" data-testid="drive-preview">
      {status === 'loading' && <div className="h-[60vh] rounded-lg bg-gray-50 animate-pulse" data-testid="drive-preview-loading" />}
      {status === 'error' && (
        <div className="h-48 flex items-center justify-center rounded-lg bg-red-50 text-sm text-red-700 px-6 text-center" data-testid="drive-preview-error">{error}</div>
      )}
      {status === 'ready' && (
        <iframe
          src={file.preview_url}
          title={file.filename}
          allow="autoplay"
          className="w-full h-[65vh] border rounded-lg bg-white"
          data-testid="drive-preview-iframe"
        />
      )}
      <p className="text-xs text-gray-500 mt-3">
        Stored in Google Drive{file.owner_account_email ? ` (${file.owner_account_email})` : ''}. If the preview asks you to sign in, use the Google account linked to this app.
      </p>
      <div className="flex gap-3 mt-4">
        <button type="button" onClick={onClose} className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors" data-testid="drive-preview-close">
          Close
        </button>
        <a
          href={file.web_view_link || file.preview_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors inline-flex items-center justify-center gap-2"
          data-testid="drive-preview-open"
        >
          <ExternalLink className="w-4 h-4" /> Open in Google Drive
        </a>
      </div>
    </div>
  );
};

export default DrivePreview;
